/**
 * Module dependencies.
 */

import { useMemo } from 'react';
import useTranslate from 'src/hooks/use-translate';

/**
 * Export `Award` type.
 */

export type Award = {
  country: string;
  title: string;
  type: string;
};

/**
 * Export `usePeixotoAwards`.
 */

export function usePeixotoAwards(): Award[] {
  const { translate } = useTranslate();

  const items = useMemo(() => {
    return [
      {
        country: translate(
          'biography-peixoto:awardsSection.award.item1.country'
        ),
        title: translate('biography-peixoto:awardsSection.award.item1.title'),
        type: translate('biography-peixoto:awardsSection.award.item1.type')
      },
      {
        country: translate(
          'biography-peixoto:awardsSection.award.item2.country'
        ),
        title: translate('biography-peixoto:awardsSection.award.item2.title'),
        type: translate('biography-peixoto:awardsSection.award.item2.type')
      },
      {
        country: translate(
          'biography-peixoto:awardsSection.award.item3.country'
        ),
        title: translate('biography-peixoto:awardsSection.award.item3.title'),
        type: translate('biography-peixoto:awardsSection.award.item3.type')
      },
      {
        country: translate(
          'biography-peixoto:awardsSection.award.item4.country'
        ),
        title: translate('biography-peixoto:awardsSection.award.item4.title'),
        type: translate('biography-peixoto:awardsSection.award.item4.type')
      },
      {
        country: translate(
          'biography-peixoto:awardsSection.award.item5.country'
        ),
        title: translate('biography-peixoto:awardsSection.award.item5.title'),
        type: translate('biography-peixoto:awardsSection.award.item5.type')
      },
      {
        country: translate(
          'biography-peixoto:awardsSection.award.item6.country'
        ),
        title: translate('biography-peixoto:awardsSection.award.item6.title'),
        type: translate('biography-peixoto:awardsSection.award.item6.type')
      },
      {
        country: translate(
          'biography-peixoto:awardsSection.award.item7.country'
        ),
        title: translate('biography-peixoto:awardsSection.award.item7.title'),
        type: translate('biography-peixoto:awardsSection.award.item7.type')
      }
    ];
  }, [translate]);

  return items;
}
